import { fetcher } from '../utils'
import { ComponentTagVO } from '@repo/types'

export default async (input: ComponentTagVO): Promise<ComponentTagVO> => fetcher(`/api/tag/save`, 'POST', input)
